import styled from 'styled-components';
import type {FC} from 'react';

interface StationBadgeProps {
    region: string | undefined;
}

const Wrapper = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 99;
    pointer-events: none;
`;

const Badge = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding: 10px 14px;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    border-radius: 10px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    pointer-events: none;
    user-select: none;
    border: 1px solid rgba(255, 255, 255, 0.06);
`;

const Primary = styled.span`
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
    letter-spacing: -0.02em;
`;

const Secondary = styled.span`
    font-weight: 500;
    font-size: 12px;
    opacity: 0.95;
    text-transform: none;
`;

export const StationBadge: FC<StationBadgeProps> = ({region}) => {
    return (
        <Wrapper>
            <Badge>
                <Primary>{region}</Primary>
                <Secondary>연계 방송</Secondary>
            </Badge>
        </Wrapper>
    );
};
